import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FooterItem } from '../footer-item.component';

@Component({
  selector: 'myre-footer-image',
  templateUrl: './footer-image.component.html',
  styleUrls: [
    '../../footer-item.component.scss',
    './footer-image.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterImageComponent extends FooterItem {
  @Input()
  public imageUrl: string;
}
